import React from 'react';
import BuilderHeader from './BuilderHeader';

const propTypes = {};

const defaultProps = {};

const BuilderLayoutHeader = () => (
  <BuilderHeader title="Global Layout" />
);

BuilderLayoutHeader.propTypes = propTypes;
BuilderLayoutHeader.defaultProps = defaultProps;

export default BuilderLayoutHeader;
